"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  /** children, react node */
  children: _propTypes.node,

  /** root element of application */
  root: _propTypes.string
};

var Modal = function Modal(_ref) {
  var children = _ref.children,
      root = _ref.root;

  var _useState = (0, _react.useState)(document.createElement("div")),
      el = _useState[0];

  (0, _react.useEffect)(function () {
    var modalRoot = document.getElementById(root || "root");
    modalRoot.appendChild(el);
    return function () {
      modalRoot.removeChild(el);
    };
  }, [el, root]);
  return /*#__PURE__*/_reactDom["default"].createPortal(children, el);
};

Modal.propTypes = propTypes;
Modal.displayName = "Modules.Modal";
var _default = Modal;
exports["default"] = _default;